import { KontentFilterable } from "types/CMS/Unum/filterable";
import { userRolesType } from "types/enums/User/Roles";

export const roleTaxonomyFilter = <TResolved extends KontentFilterable>(
  input: TResolved | undefined,
  usersRoles?: userRolesType[],
) => {
  if (!input) {
    return false;
  }

  if (!input?.roleTaxonomy || input?.roleTaxonomy?.length === 0) {
    return true;
  }

  return input.roleTaxonomy.some((taxonomy) =>
    usersRoles?.includes(taxonomy),
  );
};